import type React from 'react';
import { createContext, useEffect, useState } from 'react';

interface SubscriptionContextType {
  subscriptionSpend: number;
  setSubscriptionSpend: React.Dispatch<React.SetStateAction<number>>;
  subscriptionLimit: number;
  setSubscriptionLimit: React.Dispatch<React.SetStateAction<number>>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const SubscriptionContext = createContext<SubscriptionContextType>({
  subscriptionSpend: 0,
  setSubscriptionSpend: () => {},
  subscriptionLimit: 0,
  setSubscriptionLimit: () => {},
});

export const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [subscriptionSpend, setSubscriptionSpend] = useState<number>(() => {
    const storedSpend = localStorage.getItem('subscriptionSpend');
    return storedSpend ? Number(storedSpend) : 0;
  });

  const [subscriptionLimit, setSubscriptionLimit] = useState<number>(() => {
    const storedLimit = localStorage.getItem('subscriptionLimit');
    return storedLimit ? Number(storedLimit) : 0;
  });

  useEffect(() => {
    localStorage.setItem('subscriptionSpend', String(subscriptionSpend));
  }, [subscriptionSpend]);

  useEffect(() => {
    localStorage.setItem('subscriptionLimit', String(subscriptionLimit));
  }, [subscriptionLimit]);

  return (
    <SubscriptionContext.Provider
      value={{
        subscriptionSpend,
        setSubscriptionSpend,
        subscriptionLimit,
        setSubscriptionLimit,
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};
